export default "__VITE_ASSET__2f36f187__"